export const CATEGORY_DATA_MARK = 'data-category-section';
